<template>
    <div>
        <Spin fix v-show="isSpinShow">
            <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
        <Table ref="selectionTable" :max-height="height" :data="showData" :columns="showColumns" stripe highlight-row
            border @on-current-change="onSelectionTableChange"></Table>
        <Row style="padding:10px 0px 0px 0px">
            <Col span=3 style="padding:0px 5px 0px 0px">
            <Button long type="success" @click="onClickInsert">添加推送配置</Button>
            </Col>
            <Col span=3 style="padding:0px 5px 0px 0px">
            <Button long type="warning" @click="onClickUpdate">修改所选配置</Button>
            </Col>
            <Col span=3 style="padding:0px 5px 0px 0px">
            <Button long type="error" @click="onClickDelete">删除所选配置</Button>
            </Col>
            <Col span=15>
            <Page :current="currentPage" :total="dataCount" :page-size="pageSize" show-sizer show-total @on-change="changePage"
                @on-page-size-change="changePageSize" style="text-align:right"></Page>
            </Col>
        </Row>

        <!-- 模态框insert -->
        <Modal v-model="isShowInsertModal" :mask-closable="false" width="380">
            <p slot="header" style="color:#19be6b;text-align:center">
                <Icon type="md-create" />
                <span>报警配置</span>
            </p>
            <Form ref="formInsert" :label-width="100" :rules="ruleInsert" :model="formInsert">
                <FormItem prop="selectCommand" label="报警类型：">
                    <Select v-model="formInsert.selectCommand" placeholder="请选择命令字..." @on-change="onChangeFormInsertSelectCommand">
                        <Option v-for="(value, key) in errorSelection" :value="key + ',' +  value.name" :key="key">{{key}}--{{value.name}}</Option>
                    </Select>
                </FormItem>
                <FormItem prop="instruction" label="报警说明：">
                    <Input v-model="formInsert.instruction" placeholder="请输入报警说明..."></Input>
                </FormItem>
                <FormItem prop="content" label="推送内容：">
                    <Input v-model="formInsert.content" placeholder="请输入推送内容..." type="textarea" :autosize="{minRows: 2,maxRows: 10}"></Input>
                </FormItem>
                <FormItem prop="target" label="推送角色：">
                    <Select v-model="formInsert.target" placeholder="请选择推送角色..." v-show="isShowTarget">
                        <Option v-for="value in targetInsertOption" :value="value" :key="value">{{value}}</Option>
                    </Select>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="success" size="large" long :loading="isLoadingButton" @click="insertPushExceptionMsg">添加</Button>
            </div>
        </Modal>

        <!-- 模态框update -->
        <Modal v-model="isShowUpdateModal" :mask-closable="false" width="380">
            <p slot="header" style="color:#ff9900;text-align:center">
                <Icon type="md-create" />
                <span>报警配置</span>
            </p>
            <Form ref="formUpdate" :label-width="100" :rules="ruleInsert" :model="formUpdate">
                <FormItem prop="selectCommand" label="报警类型：">
                    <Select disabled v-model="formUpdate.selectCommand" placeholder="请选择命令字...">
                        <Option v-for="(value, key) in errorSelection" :value="key + ',' +  value.name" :key="key">{{key}}--{{value.name}}</Option>
                    </Select>
                </FormItem>
                <FormItem prop="instruction" label="报警说明：">
                    <Input v-model="formUpdate.instruction" placeholder="请输入报警说明..."></Input>
                </FormItem>
                <FormItem prop="content" label="推送内容：">
                    <Input v-model="formUpdate.content" placeholder="请输入推送内容..." type="textarea" :autosize="{minRows: 2,maxRows: 10}"></Input>
                </FormItem>
                <FormItem prop="target" label="推送角色：">
                    <Select v-model="formUpdate.target" placeholder="请选择推送角色...">
                        <Option v-for="value in targetUpdateOption" :value="value" :key="value">{{value}}</Option>
                    </Select>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="warning" size="large" long :loading="isLoadingButton" @click="updatePushExceptionMsg">修改</Button>
            </div>
        </Modal>

        <!-- 模态框delete -->
        <Modal v-model="isShowDeleteModal" :mask-closable="false" width="380">
            <p slot="header" style="color:#ed4014;text-align:center">
                <Icon type="md-create" />
                <span>报警配置</span>
            </p>
            <div style="color:#ed4014;text-align:center">
                是否确认删除所选数据？
            </div>
            <div slot="footer">
                <Button type="error" size="large" long :loading="isLoadingButton" @click="deletePushExceptionMsg">删除</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    export default {
        name: "push_exception_config",
        created() {
            this.showPage();
        },
        data() {
            return {
                height: document.body.clientHeight * 0.7,
                isLoadingButton: false,
                isShowInsertModal: false,
                isShowUpdateModal: false,
                isShowDeleteModal: false,
                isShowTarget: false,
                targetInsertOption: [],
                targetUpdateOption: [],
                isSpinShow: false,
                currentPage: 1,
                dataCount: 0,
                pageSize: 10,
                showData: [],
                showColumns: [{
                        title: "报警位索引",
                        key: "infoPushExceptionMsgIndex",
                        width: 100
                    },
                    {
                        title: "报警名称",
                        key: "infoPushExceptionMsgName"
                    },
                    {
                        title: "报警说明",
                        key: "infoPushExceptionMsgInstruction"
                    },
                    {
                        title: "推送内容",
                        key: "infoPushExceptionMsgContent"
                    },
                    {
                        title: "推送对象",
                        key: "infoPushExceptionMsgTarget"
                    }
                ],
                errorSelection: global.errorMsgParam,
                infoPushExceptionMsg: {},
                infoPushExceptionMsgForUpdate: null,
                formInsert: {
                    selectCommand: "",
                    instruction: "",
                    content: "",
                    target: ""
                },
                formUpdate: {
                    selectCommand: "",
                    instruction: "",
                    content: "",
                    target: ""
                },
                ruleInsert: {
                    selectCommand: [{
                        required: true,
                        message: '请选择报警类型...',
                        trigger: 'change'
                    }],
                    instruction: [{
                        required: true,
                        message: '请输入报警说明...',
                        trigger: 'blur'
                    }],
                    content: [{
                        required: true,
                        message: '请输入推送内容...',
                        trigger: 'blur'
                    }],
                    target: [{
                        required: true,
                        message: '请选择推送角色...',
                        trigger: 'change'
                    }]
                }
            }
        },
        methods: {
            changePage(index) {
                this.currentPage = index;
                this.showPage();
            },
            changePageSize(size) {
                this.pageSize = size;
                this.showPage();
            },
            showPage() {
                var that = this;
                that.isSpinShow = true;
                $.ajax({
                    url: "/api/pushExceptionMsg/selectPage?page=" +
                        this.currentPage +
                        "&pageAmount=" +
                        this.pageSize,
                    contentType: "application/json",
                    type: "post",
                    dataType: "json",
                    data: JSON.stringify(that.infoPushExceptionMsg),
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }
                        that.showData = data.body.resultList;
                        that.dataCount = data.body.amount;
                        that.isSpinShow = false;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    }
                });
            },
            onChangeFormInsertSelectCommand() {
                var that = this;
                var infoPushExceptionMsgTemp = {};
                var index = this.formInsert.selectCommand.indexOf(",");
                var obj = this.formInsert.selectCommand.substring(0, index);
                infoPushExceptionMsgTemp["infoPushExceptionMsgIndex"] = parseInt(obj);
                $.ajax({
                    url: "/api/pushExceptionMsg/selectPage?page=0&pageAmount=" +
                        this.pageSize,
                    contentType: "application/json",
                    type: "post",
                    dataType: "json",
                    data: JSON.stringify(infoPushExceptionMsgTemp),
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }
                        that.formInsert.target = "";
                        that.targetInsertOption = ["燃气用户", "安全负责人", "工程人员"];
                        data.body.resultList.map(item => {
                            var index = that.targetInsertOption.indexOf(item.infoPushExceptionMsgTarget);
                            if (index >= 0) {
                                that.targetInsertOption.splice(index, 1);
                            }
                        });
                        that.isShowTarget = true;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    }
                });
            },
            insertPushExceptionMsg() {
                var that = this;
                that.isLoadingButton = true;
                var infoPushExceptionMsgInsert = {};
                var index = this.formInsert.selectCommand.indexOf(",");
                var obj1 = this.formInsert.selectCommand.substring(0, index);
                var obj2 = this.formInsert.selectCommand.substring(index + 1, this.formInsert.selectCommand.length);
                infoPushExceptionMsgInsert["infoPushExceptionMsgIndex"] = parseInt(obj1);
                infoPushExceptionMsgInsert["infoPushExceptionMsgName"] = obj2;
                infoPushExceptionMsgInsert["infoPushExceptionMsgInstruction"] = this.formInsert.instruction;
                infoPushExceptionMsgInsert["infoPushExceptionMsgContent"] = this.formInsert.content;
                infoPushExceptionMsgInsert["infoPushExceptionMsgTarget"] = this.formInsert.target;
                that.targetInsertOption.splice(that.targetInsertOption.indexOf(this.formInsert.target), 1);
                that.$refs['formInsert'].validate((valid) => {
                    if (valid) {
                        $.ajax({
                            url: "api/pushExceptionMsg/insert",
                            contentType: "application/json",
                            type: "post",
                            dataType: "json",
                            data: JSON.stringify(infoPushExceptionMsgInsert),
                            success: function(data) {
                                if (data.errorCode != 0) {
                                    that.$Notice.error({
                                        title: "异常",
                                        desc: data.errorInfo
                                    });
                                    that.isShowInsertModal = false;
                                    return;
                                }
                                that.isShowInsertModal = false;
                                that.formInsert.target = "";
                                that.isLoadingButton = false;
                                that.showPage();
                            },
                            error: function(textStatus) {
                                that.$Notice.error({
                                    title: "异常",
                                    desc: "接口请求异常"
                                });
                            }
                        });
                    }
                });
            },
            updatePushExceptionMsg() {
                var that = this;
                that.isLoadingButton = true;
                var infoPushExceptionMsgUpdate = {};
                infoPushExceptionMsgUpdate["infoPushExceptionMsgId"] = this.infoPushExceptionMsgForUpdate.infoPushExceptionMsgId;
                infoPushExceptionMsgUpdate["infoPushExceptionMsgInstruction"] = this.formUpdate.instruction;
                infoPushExceptionMsgUpdate["infoPushExceptionMsgContent"] = this.formUpdate.content;
                infoPushExceptionMsgUpdate["infoPushExceptionMsgTarget"] = this.formUpdate.target;
                that.$refs['formUpdate'].validate((valid) => {
                    if (valid) {
                        $.ajax({
                            url: "api/pushExceptionMsg/update",
                            contentType: "application/json",
                            type: "post",
                            dataType: "json",
                            data: JSON.stringify(infoPushExceptionMsgUpdate),
                            success: function(data) {
                                if (data.errorCode != 0) {
                                    that.$Notice.error({
                                        title: "异常",
                                        desc: data.errorInfo
                                    });
                                    that.isShowUpdateModal = false;
                                    return;
                                }
                                that.isShowUpdateModal = false;
                                that.isLoadingButton = false;
                                that.showPage();
                            },
                            error: function(textStatus) {
                                that.$Notice.error({
                                    title: "异常",
                                    desc: "接口请求异常"
                                });
                            }
                        });
                    }
                });
            },
            deletePushExceptionMsg() {
                var that = this;
                that.isLoadingButton = true;
                var infoPushExceptionMsgDelete = {};
                infoPushExceptionMsgDelete["infoPushExceptionMsgId"] = this.infoPushExceptionMsgForUpdate.infoPushExceptionMsgId;
                $.ajax({
                    url: "api/pushExceptionMsg/delete",
                    contentType: "application/json",
                    type: "post",
                    dataType: "json",
                    data: JSON.stringify(infoPushExceptionMsgDelete),
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            that.isShowDeleteModal = false;
                            return;
                        }
                        that.isShowDeleteModal = false;
                        that.isLoadingButton = false;
                        that.showPage();
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    }
                });
            },
            onSelectionTableChange(currentRow, oldCurrentRow) {
                this.infoPushExceptionMsgForUpdate = currentRow;
                var that = this;
                var infoPushExceptionMsgTemp = {};
                infoPushExceptionMsgTemp["infoPushExceptionMsgIndex"] =
                    parseInt(this.infoPushExceptionMsgForUpdate.infoPushExceptionMsgIndex);
                $.ajax({
                    url: "/api/pushExceptionMsg/selectPage?page=0&pageAmount=" +
                        this.pageSize,
                    contentType: "application/json",
                    type: "post",
                    dataType: "json",
                    data: JSON.stringify(infoPushExceptionMsgTemp),
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }
                        that.targetUpdateOption = ["燃气用户", "安全负责人", "工程人员"];
                        data.body.resultList.map(item => {
                            var index = that.targetUpdateOption.indexOf(item.infoPushExceptionMsgTarget);
                            if (index >= 0 && item.infoPushExceptionMsgTarget !=
                                that.infoPushExceptionMsgForUpdate.infoPushExceptionMsgTarget) {
                                that.targetUpdateOption.splice(index, 1);
                            }
                        });
                        that.formUpdate.target = that.infoPushExceptionMsgForUpdate.infoPushExceptionMsgTarget;
                        that.formUpdate.selectCommand = that.infoPushExceptionMsgForUpdate.infoPushExceptionMsgIndex +
                            "," +
                            that.infoPushExceptionMsgForUpdate.infoPushExceptionMsgName;
                        that.formUpdate.instruction = that.infoPushExceptionMsgForUpdate.infoPushExceptionMsgInstruction;
                        that.formUpdate.content = that.infoPushExceptionMsgForUpdate.infoPushExceptionMsgContent;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    }
                });
            },
            onClickInsert() {
                this.isShowInsertModal = true;
                this.onChangeFormInsertSelectCommand();
            },
            onClickUpdate() {
                if (this.infoPushExceptionMsgForUpdate != null) {
                    this.isShowUpdateModal = true;
                } else {
                    this.$Notice.error({
                        title: "警告",
                        desc: "请选择一条数据！"
                    });
                }
            },
            onClickDelete() {
                if (this.infoPushExceptionMsgForUpdate != null) {
                    this.isShowDeleteModal = true;
                } else {
                    this.$Notice.error({
                        title: "警告",
                        desc: "请选择一条数据！"
                    });
                }
            }
        }
    }
</script>

<style>
    .ivu-table td,
    .ivu-table th {
        min-width: 0;
        height: 30px;
        box-sizing: border-box;
        text-align: center;
        text-overflow: ellipsis;
        vertical-align: middle;
        border-bottom: 1px solid #e8eaec;
    }
</style>
